import { render } from "./AddDepartment.vue?vue&type=template&id=f37ce45a&scoped=true"
import script from "./AddDepartment.vue?vue&type=script&lang=js"
export * from "./AddDepartment.vue?vue&type=script&lang=js"

import "./AddDepartment.vue?vue&type=style&index=0&id=f37ce45a&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f37ce45a"]])

export default __exports__